import {
  AdjustmentCreate,
  AdjustmentSummary,
  WriteOffCreate,
} from "@/types/adjustment";

import { requestData } from "@/api/api-config";

export async function createAdjustment(
  adjustment: AdjustmentCreate,
): Promise<AdjustmentSummary | null> {
  return await requestData<AdjustmentSummary>(
    "billing/adjustment/create",
    "post",
    {
      json: adjustment,
    },
  );
}

export async function writeOffCharge(
  adjustment: WriteOffCreate,
): Promise<AdjustmentSummary | null> {
  return await requestData<AdjustmentSummary>(
    "billing/write-off/create",
    "post",
    {
      json: adjustment,
    },
  );
}
